.disclosure {
	& [data-icon='chevron-right'] {
		rotate: 0deg;
		transition: rotate var(--lp-duration-200);
	}

	&[data-expanded] [slot='trigger'] [data-icon='chevron-right'] {
		rotate: 90deg;
	}
}

.panel {
	padding: 0 var(--lp-spacing-300);
}
